module.exports = __webpack_public_path__ + "img/logo.33f8bf94.png";